import {
  PageNode,
  LeafNode,
  NavigationNode,
  NodeKind,
} from "blog/json_nodes"

export const createPage = (
  navigation: NavigationNode,
  content: LeafNode,
): PageNode => {
  return { kind: NodeKind.PAGE, navigation, content }
}
